import { render, staticRenderFns } from "./registre.html?vue&type=template&id=330c44ba&scoped=true&external"
import script from "./registre.js?vue&type=script&lang=js&external"
export * from "./registre.js?vue&type=script&lang=js&external"
import style0 from "./registre.scss?vue&type=style&index=0&id=330c44ba&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330c44ba",
  null
  
)

export default component.exports